var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAddContadoMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 1.6875C7.625 1.43886 7.52623 1.2004 7.35041 1.02459C7.1746 0.848772 6.93614 0.75 6.6875 0.75C6.43886 0.75 6.2004 0.848772 6.02459 1.02459C5.84877 1.2004 5.75 1.43886 5.75 1.6875V5.75H1.6875C1.43886 5.75 1.2004 5.84877 1.02459 6.02459C0.848772 6.2004 0.75 6.43886 0.75 6.6875C0.75 6.93614 0.848772 7.1746 1.02459 7.35041C1.2004 7.52623 1.43886 7.625 1.6875 7.625H5.75V11.6875C5.75 11.9361 5.84877 12.1746 6.02459 12.3504C6.2004 12.5262 6.43886 12.625 6.6875 12.625C6.93614 12.625 7.1746 12.5262 7.35041 12.3504C7.52623 12.1746 7.625 11.9361 7.625 11.6875V7.625H11.6875C11.9361 7.625 12.1746 7.52623 12.3504 7.35041C12.5262 7.1746 12.625 6.93614 12.625 6.6875C12.625 6.43886 12.5262 6.2004 12.3504 6.02459C12.1746 5.84877 11.9361 5.75 11.6875 5.75H7.625V1.6875Z",
    fill: "#88B13B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddContadoMethod);
export default __webpack_public_path__ + "static/media/ic_add_contado_method.3382088f3997553b82490875a0625a99.svg";
export { ForwardRef as ReactComponent };